import Vue from 'vue/dist/vue.esm';
import TurbolinksAdapter from 'vue-turbolinks';
import itemsComponent from '../../vue/marketplace_v2/items/index.vue';

setLanguage();

Vue.prototype.i18n = window.i18n;
Vue.use(TurbolinksAdapter);

if (window.itemsComponent) {
  window.itemsComponent.$destroy(true);
}

window.itemsComponent = new Vue({
  el: '#items-index',
  components: { itemsComponent }
});
